export default {
  heading: "Agencja usług księgowych",
  published: "Wysłany dnia",
  zero_posts: "Nie dodano jeszcze żadnych postów na blogu",
  menu_btns: {
    welcome: "Początek",
    services: "Usługi",
    accounting: "Księgowość",
    social_services: "Służby socjalne",
    about_us: "O nas",
    price_list: "Cennik",
    promotions: "Promocje",
    promotion_accounting: "Promocja - Księgowość",
    promotion_services: "Promocja - Usługi",
    forms: "Formularze",
    contacts: "Łączność",
    blog: "Blog",
  },
  routes: {
    welcome: {
      intro:
        "to licencjonowane biuro rachunkowe w Wielkiej Brytanii. Jesteśmy oficjalnie zarejestrowani jako agent podatkowy i celny w Wielkiej Brytanii - HMRC. Podlegamy nadzorowi przeciw praniu pieniędzy, posiadamy ubezpieczenie od odpowiedzialności zawodowej, jesteśmy zarejestrowani w Information Commissioner's Office (ICO), odpowiedzialnym za ochronę danych osobowych.",
      heading: "Co oferujemy",
      p1:
        "Jako licencjonowany księgowy reprezentujemy Cię przed brytyjskim urzędem skarbowym w związku z Twoimi sprawami podatkowymi.",
      p2:
        "Posiadamy dwa biura - DoKument i Biurokrat, w których oferujemy następujące usługi:",
      p3:
        "W naszym biurze DoKument świadczymy pełen zakres usług księgowych, zarówno dla osób samozatrudnionych - samozatrudnionych / jednoosobowych, jak i dla firm z ograniczoną odpowiedzialnością. Pełen pakiet naszych usług znajdziesz ",
      p4:
        "W naszym biurze Biurokrat zapewniamy pełen zakres usług socjalnych - tłumaczenia na język bułgarski i polski przez licencjonowanych tłumaczy, pomoc w ubieganiu się o świadczenia socjalne w Wielkiej Brytanii, zasiłki na dzieci, zwrot nadpłaconych podatków i ubezpieczenia, macierzyństwo i inne. Pełen pakiet naszych usług możesz zobaczyć ",
      p5:
        "W naszej wieloletniej praktyce w Wielkiej Brytanii udało nam się sprawdzić się jako specjaliści, jak również stworzyć dobre relacje z klientami, aby odpowiedzieć na zapytania w jak najkrótszym czasie. Mamy setki wygranych przeciwko nam odwołań przeciwko karom nałożonym przez organy podatkowe. Kierując się przepisami prawa, naszym celem jest dostarczenie najbardziej optymalnego rozwiązania dla Twojego biznesu i jego rozwoju. Każdego klienta traktujemy indywidualnie, a nasze doświadczenie pozwoliło nam porozumieć się z klientem w zrozumiałym dla obu stron języku księgowym. Są to warunki niezbędne do posiadania bogatego portfolio klientów.",
      p6:
        "Aby zachęcić naszych stałych i zadowolonych klientów, opracowaliśmy program promocyjny „Poleć znajomemu”, którego warunki można znaleźć ",
      conclusion: "Zaufały nam setki firm! Zaufaj nam!",
      span_here: "tutaj",
      footer: {
        office: "Biuro",
        open_hours: "Czas pracy:",
      },
    },
    accounting: {
      heading: "Usługi księgowe",
      top: {
        limited_companies: {
          vat_returns: "(Deklaracje VAT)",
          ltd: "Rejestracja Ltd.",
        },
        solo_trader: {
          register: "Rejestracja jako osoba samozatrudniona",
          decl: "Roczne zeznanie podatkowe",
          vat: "(zwrot VAT)",
        },
        insurance: {
          heading: "Ubezpieczenie biznesowe",
          importance:
            "Niezwykle ważne jest posiadanie ubezpieczenia biznesowego, aby uzyskać ochronę na wypadek niezadowolenia klienta z Twoich usług i zgłoszenia roszczenia o odszkodowanie.",
          employer:
            "Jeśli jesteś pracodawcą, masz prawny obowiązek posiadania ubezpieczenia od odpowiedzialności cywilnej.",
          responsible: "Nie lekceważ tych obowiązków!",
        },
      },
      bottom: [
        {
          heading:
            "Różnice między przedsiębiorcą jednoosobowym ( sole Trader) oraz spółka z ograniczoną odpowiedzialnością (Limited Company)",
          content:
            "Zapoznaj się z naszymi definicjami, porównaj zalety i wady oraz dowiedz się, która struktura biznesowa najlepiej odpowiada Twoim potrzebom. Każda firma - bez względu na to, jak duża czy mała - musi mieć strukturę prawną. W Wielkiej Brytanii około 3,3 miliona osób pracuje jako jednoosobowa działalność gospodarcza, a 1,6 miliona jako LTD. Jaka jest różnica między nimi? A co byłoby najlepsze dla Twojej firmy?",
        },
        {
          heading: "Przedsiębiorca indywidualny (self-employed)",
          content:
            "Osoba prowadząca działalność gospodarczą to zasadniczo osoba prowadząca działalność na własny rachunek, która jest jedynym właścicielem swojej firmy. To najprostsza struktura biznesowa - co czyni ją najbardziej popularną. Rejestracja do celów podatkowych jest łatwa i prosta.",
        },
        {
          heading: "Spółka z ograniczoną odpowiedzialnością (LTD)",
          content:
            "Spółka z ograniczoną odpowiedzialnością to rodzaj struktury biznesowej, która ma własną tożsamość prawną, odrębną od jej właścicieli (akcjonariuszy) i menedżerów (dyrektorów). Dzieje się tak nawet wtedy, gdy zarządza nim jedna osoba, w charakterze akcjonariusza i dyrektora. Właściciel jednoosobowy czy spółka z ograniczoną odpowiedzialnością? Każda struktura ma swoje zalety i wady, więc przyjrzyjmy się bliżej opcji jednego przedsiębiorcy.",
        },
        {
          heading: "Przedsiębiorca indywidualny - zalety",
          content:
            "Łatwo jest stworzyć stosunkowo niewielką ilość papierkowej roboty, konieczne przestawianie podatków raz w roku. Większa poufność niż w przypadku spółki z ograniczoną odpowiedzialnością, której dane można przeglądać w Companies House.",
        },
        {
          heading: "Przedsiębiorca indywidualny - wady",
          content:
            "Przedsiębiorcy indywidualni ponoszą nieograniczoną odpowiedzialność, ponieważ zgodnie z prawem Wielkiej Brytanii nie są uważani za odrębną jednostkę prawną. Oznacza to, że jeśli firma popadnie w długi, właściciel firmy jest osobiście odpowiedzialny. W ten sposób osoby prowadzące jednoosobową działalność gospodarczą mogą stracić swoje aktywa osobiste, jeśli coś pójdzie nie tak. Finansowanie bankowe może być trudne, ponieważ banki i inni inwestorzy preferują spółki z ograniczoną odpowiedzialnością. Ogranicza to zakres ekspansji przedsiębiorców jednoosobowych. Stawki podatkowe dla osób prowadzących jednoosobową działalność gospodarczą nie zawsze są tak wysokie, jak dla spółek z ograniczoną odpowiedzialnością. Kiedy osiągniesz określony poziom zysku, pozostanie przedsiębiorcą jednoosobowym staje się nieopłacalne. Jakie są więc wady i zalety zakładania spółki z ograniczoną odpowiedzialnością?",
        },
        {
          heading: "Zalety spółki z ograniczoną odpowiedzialnością",
          content:
            "W przeciwieństwie do przedsiębiorcy jednoosobowego, spółka z ograniczoną odpowiedzialnością ma tę zaletę, że jest ograniczona odpowiedzialnością, ponieważ istnieje prawne rozróżnienie między właścicielem firmy a jego działaniami. Oznacza to, że aktywa osobiste nie są zagrożone utratą, a jedynie to, co zainwestowałeś w firmę. Ogólnie rzecz biorąc, spółki z ograniczoną odpowiedzialnością są bardziej efektywne podatkowo niż osoby prowadzące jednoosobową działalność gospodarczą. Obecnie stawki podatkowe dotyczące opodatkowania zysków są niższe dla spółek z ograniczoną odpowiedzialnością niż dla osób prowadzących jednoosobową działalność gospodarczą. Ponadto spółki z ograniczoną odpowiedzialnością mają możliwość odpisania szerokiego zakresu kosztów, co zmniejsza zyski i należne podatki.",
        },
        {
          heading: "Wady spółki z ograniczoną odpowiedzialnością",
          content:
            "Dyrektor spółki z ograniczoną odpowiedzialnością ma obowiązki prawne (obowiązki powiernicze dyrektora), które muszą być ściśle wykonywane, co z kolei wymaga czasu i uwagi. Raporty i deklaracje, które trzeba składać w urzędzie skarbowym są znacznie bardziej złożone i liczne, co wymaga od dyrektora większej ilości czasu lub zatrudnienia księgowego, co wiąże się z dodatkowymi kosztami. Za utworzenie, wystawienie raportów i zamknięcie spółki z ograniczoną odpowiedzialnością pobierane są opłaty administracyjne, które są uiszczane na rzecz Companies House. Szczegóły dotyczące dyrektorów i przychodów Twojej firmy muszą być ujawnione publicznie. Nie wszystkim podoba się ten rodzaj przejrzystości. Ostatecznie bardzo ważne jest zważenie różnic między jednoosobową działalnością gospodarczą a spółką z ograniczoną odpowiedzialnością,",
        },
      ],
      footer:
        "Nie spiesz się z podjęciem decyzji, skonsultuj się, ponieważ każda firma jest indywidualna. Dokonuj świadomych wyborów, aby mieć pewność, że od samego początku położyłeś właściwy fundament.",
    },
    services: {
      heading: "Inne usługi społeczne",
      paragraphs: [
        {
          heading: "Nagraj wywiad dla National insurance number",
          content:
            "Numer ubezpieczenia społecznego (NINo) w Wielkiej Brytanii jest absolutnie niezbędny i ważny - jeśli szukasz pracy, rozpoczynasz pracę lub rozpoczynasz działalność gospodarczą. Numer ubezpieczenia społecznego (NINo) to numer, pod którym rejestrowane są wszystkie Twoje podatki i składki na ubezpieczenie społeczne. Datę i godzinę wydania NINo zarejestrujemy w najbliższym Jobcentre.",
        },
        {
          heading: "Zwrot nadpłaconych podatków i ubezpieczeń",
          content:
            "Jeśli pracowałeś nad niewłaściwym kodem podatkowym lub nie pracowałeś przez cały rok podatkowy, a także opuszczając Wielką Brytanię, istnieje większe prawdopodobieństwo, że otrzymasz zwrot podatku. Skontaktuj się z nami w celu bezpłatnej kalkulacji.",
        },
        {
          heading: "Stan macierzyństwa (Maternity allowance)",
          content:
            "Osoby, które nie mają prawa do urlopu macierzyńskiego u swojego pracodawcy, mogą ubiegać się o urlop macierzyński od państwa. Skontaktuj się z nami aby dostać darmową poradę.",
        },
        {
          heading:
            "Zasiłki dla dzieci (child benefit) i świadczenia socjalne dla osób o niskich dochodach (Universal credit)",
          content:
            "Jeśli pracujesz w Wielkiej Brytanii i masz dzieci lub masz niskie dochody, możesz ubiegać się o zasiłki socjalne. Skontaktuj się z nami, aby doradzić, jakie świadczenia są dostępne w okolicy, w której mieszkasz.",
        },
      ],
    },
    about_us: {
      ani: {
        job:
          "Anna Atanasova - Główna Księgowa i właścicielka biur DoKument i Biurokrat",
        texts: [
          "Anna jest absolwentką Uniwersytetu Ekonomicznego w Warnie w Bułgarii na wydziale finansów i kontroli księgowej.",
          "Podczas studiów w latach 2007-2009 Anna pracowała jako księgowa w niektórych z najbardziej prestiżowych hoteli i restauracji na bułgarskim wybrzeżu Morza Czarnego.",
          "W latach 2011-2014 Anna studiowała i ukończyła AAT Education w Wielkiej Brytanii.",
          "Staż w Wielkiej Brytanii rozpoczął jako księgowy w 2015 roku w firmie Biurokrat w Crewe. W 2016 roku zaczął świadczyć niezależne usługi księgowe pod nazwą BAJ Accounting. Jej zaangażowanie w pracę i profesjonalizm są okazją do rozwoju firmy, dlatego Anna powinna poszukać partnera w osobie jej byłego pracodawcy - pani Eleny Cholakovej, właścicielki biura Biurokrat. W efekcie w maju 2020 roku otwarto biuro rachunkowe DoKument, którego właścicielami są Anna Atanasova i Elena Cholakova, a od września 2020 roku Anna została również współwłaścicielem biura Biurokrat, Crewe.",
        ],
        hobby:
          "Anna poza pracą poświęca się rodzinie, z którą uwielbia podróżować.",
      },
      elena: {
        job:
          "Elena Cholakova - Główna Księgowa i właścicielka biur DoKument i Biurokrat",
        texts: [
          "Eli posiada dyplom z zarządzania biznesem na Thames Valley University w Wielkiej Brytanii.",
          "W 2002 roku rozpoczął praktykę w Wielkiej Brytanii jako księgowy operacyjny i kadrowo-płacowy. W 2014 roku założył biuro Biurokrat, w którym w 2015 roku poznał Annę Atanasovą. W tym okresie Ellie udało się zakwalifikować jako księgowa w Institute of Certified Bookkeepers. W 2016 roku Eli został licencjonowanym tłumaczem języka bułgarskiego i został zarejestrowany w lokalnej gminie jako przedstawiciel społeczności bułgarskiej na tym obszarze. Od wiosny 2019 roku Eli rozpoczął współpracę z BAJ Accounting, w wyniku czego w maju 2020 roku został współwłaścicielem tej firmy o zmienionej już nazwie - DoKument Ltd.",
        ],
        hobby:
          "Poza pracą Ellie oddaje się rodzinie, podróżom i wydarzeniom kulturalnym.",
      },
      radoslava: {
        job:
          "Radoslava Ivanova - księgowa operacyjna i sekretarz biura DoKument",
        texts: [
          "Radi współpracuje z nami od otwarcia Biura Dokumentacji w lipcu 2020 roku.",
          "Radi zdobywał doświadczenie jako księgowy operacyjny w Bułgarii, z 7-letnim doświadczeniem jako jeden z największych producentów żywności w kraju.",
          "Od 2007 do 2012 roku Radi kontynuował swoje doświadczenie w firmie opiekującej się osobami z ubytkiem słuchu. Tam, oprócz pracy administracyjnej, Radiowi udało się zdobyć doświadczenie w komunikowaniu się z osobami z różnymi problemami społecznymi.",
          "Jest to warunek konieczny, aby Radi znalazł swoją wymarzoną pracę za granicą jako członek naszego zespołu.",
        ],
        hobby:
          "Oprócz współpracy z nami, Radi jest organizatorem obecnego Bułgarskiego Klubu Tańca Folklorystycznego - Telford. W wolnym czasie Radi uwielbia czytać książki i przekazywać za granicą naszą kulturę i tradycje.",
      },
      boyana: {
        job:
          "Boyana Koleva - księgowa operacyjna i doradca ds. Pomocy społecznej w biurze Biurokrat",
        texts: [
          "Bobby ukończyła ekonomię na Uniwersytecie w Warnie i kontynuuje studia magisterskie z rachunkowości na Uniwersytecie w Płowdiwie, które ukończyła w 2007 roku.",
          "Podczas studiów Bobby pracował jako księgowy i audytor operacyjny.",
          "W latach 2012-2014 studiował rachunkowość w Wielkiej Brytanii, w szczególności - komputerowy program księgowy Sage 50.",
          "Bobby rozpoczął staż w Wielkiej Brytanii pod koniec 2017 roku w biurze Biurokrat, w którym pracuje do dziś.",
        ],
        hobby: "W wolnym czasie Bobby poświęca się rodzinie.",
      },
      irena: {
        job:
          "Irena Darakchieva - główna asystentka księgowa w biurze DoKument.",
        texts: [
          "Irena pracuje z nami od połowy listopada 2020 roku.",
          "Irena w swojej praktyce współpracuje z ludźmi różnych narodowości, co jest warunkiem doskonałej komunikacji z klientami.",
          "Irena przez lata zdobywała kwalifikacje, które pozwalają jej zajmować kierownicze stanowiska w znanych na całym świecie firmach.",
          "Pewność siebie i dobra komunikacja, jaką posiada, dały Irenie możliwość objęcia jednego z najważniejszych stanowisk w naszym zespole, a mianowicie bezpośredniej komunikacji z Tobą - klientami.",
        ],
        hobby:
          "W wolnym czasie Irenka uwielbia uczyć się nowych rzeczy, wzbogacać się zawodowo i spotykać się z przyjaciółmi.",
      },
    },
    pricelist: {
      headings: ["Opis", "Cena"],
      rows: [
        [
          "Rejestracja ograniczona - obejmuje PAYE, rejestrację VAT i opłatę stanową",
          "£95.00",
        ],
        [
          "Ograniczona rejestracja kompletna - obejmuje PAYE, rejestrację VAT, opłatę stanową i firmowe konto bankowe",
          "£135.00",
        ],
        [
          "Roczne rozliczenie firm, zeznanie podatkowe od osób prawnych i rachunki na koniec roku od 600,00 GBP / 50,00 GBP (miesiąc)",
          "@",
        ],
        [
          "Paski wypłaty, roczny koszt pracownika wynosi 60,00 GBP / 5,00 GBP (miesiąc)",
          "@",
        ],
        [
          "Deklaracje VAT - 240,00 GBP rocznie / 60,00 GBP na kwartał / 20,00 GBP miesięcznie",
          "@",
        ],
        [
          "Roczne oświadczenie osób samodzielnie ubezpieczonych - zeznanie podatkowe do samodzielnego rozliczenia",
          "£100.00",
        ],
        ["Rejestracja osób samozatrudnionych", "£35.00"],
        ["Rejestracja w systemie budowy - CIS", "£20.00"],
        ["Otwarcie konta biznesowego - Konto biznesowe", "£60.00"],
        ["Ubezpieczenie biznesowe - pakiet ubezpieczeń OC", "£30.00"],
        ["Złóż wniosek o pożyczkę w Bounce Bank", "£50.00"],
        ["Uniwersalny kredyt", "£80.00"],
        [
          "P85 / P38 (zwrot nadpłaconych podatków) od 15,00 GBP do 150,00 GBP",
          "10.00%",
        ],
        ["Dodatek na dziecko", "@"],
        ["Dzieci urodzone w Wielkiej Brytanii *", "£30.00"],
        ["Dzieci urodzone poza Wielką Brytanią *", "£50.00"],
        ["Dzieci urodzone i mieszkające w innym kraju europejskim *", "£70.00"],
        ["Odzyskaj utracony numer ubezpieczenia społecznego", "£30.00"],
        ["Utwórz osobiste konto podatkowe", "£20.00"],
        ["Wniosek o kredyt emerytalny *", "£80.00"],
        ["Korekta błędnego kodeksu podatkowego", "£30.00"],
        ["Wniosek o zasiłek macierzyński", "£50.00"],
      ],
      extra_tax: "* Istnieje dodatkowa opłata za przesyłkę",
      price_avarage:
        "Ceny są orientacyjne i mogą ulec zmianie w zależności od konkretnego przypadku!",
    },
    contacts: {
      left_side: {
        title: "Skontaktuj się z nami",
        labels: {
          name: "Иmię",
          email: "E-mail",
          phone: "Telefon",
          message: "Wiadomość",
        },
        btn_submit: "Zatwierdź",
      },
      right_side: {
        title: "Potrzebujesz pomocy?",
        title_secondary: "Jesteśmy zawsze gotowi do pomocy.",
        text:
          "Wyślij nam zapytanie bezpośrednio, wypełniając ten formularz łatwo, szybko i wygodnie. Podaj poprawnie swoje dane, abyśmy mogli skontaktować się z Tobą na podany adres e-mail.",
        office: "Biuro",
        address: "Adres",
        email: "E-mail",
        phone: "Telefon",
        mobile_phone: "Telefon komórkowy",
      },
      success_msg:
        "Dziękujemy za skontaktowanie się z nami! Wkrótce do Ciebie wrócimy!",
    },
    promotions: {
      accounting: {
        heading_1: "PROGRAM PROMOCYJNY",
        heading_2: "„POLECAJ ZNAJOMEMU”",
        intro: {
          p1:
            "Masz przyjaciela lub współpracownika, który potrzebuje usług księgowych?",
          p2: "Jesteś z nas zadowolony i chcesz nas polecić?",
          p3: "Specjalnie dla Ciebie opracowaliśmy program promocyjny",
        },
        container_1: {
          heading: "Co robić",
          p1:
            "Wyślij nam e-mail z kontaktami Twojego przyjaciela lub współpracownika - imię i nazwisko, numer telefonu, adres e-mail.",
          p2:
            "Jeśli osoba nie chce mieć kontaktów, przekaż je DoKument i poproś klienta o podanie swoich nazwisk.",
        },
        container_2: {
          heading: "Co otrzymasz",
          p1:
            "Jako rekomendację dla potencjalnego klienta - osoby samozatrudnionej / osoby prowadzącej jednoosobową działalność gospodarczą, otrzymasz kartę podarunkową o wartości 10,00 GBP, którą możesz wykorzystać w ponad 50 sklepach w Wielkiej Brytanii. Nagrodę otrzymasz po dokonaniu płatności przez poleconego przez Ciebie klienta.",
          p2:
            "Za rekomendację dla potencjalnego klienta z Limited Company - otrzymujesz kartę podarunkową o wartości 50,00 GBP, którą możesz wykorzystać w ponad 50 sklepach w Wielkiej Brytanii. Nagroda zostanie odebrana po tym, jak klient, któremu nas poleciłeś, dokona nam 3 miesięcznych płatności na podstawie rocznego planu płatności.",
        },
        container_3: {
          heading: "Regulamin",
          p1:
            "Promocja jest ważna tylko dla klientów, którzy płacą nam regularnie.",
          p2:
            "Promocja nie dotyczy tych z Państwa, którzy już z nami nie pracują.",
          p3:
            "Promocja jest ważna tylko dla przyszłych klientów, którzy będą korzystali z usług księgowych - osoby samozatrudnione / osoby prowadzące jednoosobową działalność gospodarczą lub spółki Limited.",
          p4:
            "Promocja obowiązuje tylko w przypadku rekomendacji przyszłemu klientowi, który po raz pierwszy skorzysta z naszej usługi.",
        },
        terms: {
          p1:
            "Program promocyjny obowiązuje od 17.08.2020 do 31.12.2020 włącznie **",
          p2:
            "** W przypadku nadużyć zastrzegamy sobie prawo do wycofania promocji w dowolnym momencie bez uprzedzenia!",
        },
      },
      services: {
        heading_1: "PROGRAM PROMOCYJNY",
        heading_2: '"STALI KLIENCI"',
        intro: {
          p1: "Potrzebujesz skorzystać z naszych usług?",
          p2: "Czy jesteś zadowolony i potrzebujesz dodatkowej pomocy?",
          p3: "Specjalnie dla Ciebie opracowaliśmy program promocyjny!",
        },
        container_1: {
          heading: "Z czego składa się program?",
          p1:
            "Do programu może przystąpić każdy klient korzystający z oferowanych przez nas usług społecznościowych.",
          p2:
            "Program obowiązuje jako pakiet dla jednej rodziny mieszkającej pod tym samym adresem.",
        },
        container_2: {
          heading: "Co otrzymasz",
          p1:
            "Otrzymasz kartę podarunkową, której możesz użyć do zakupów w ponad 50 sklepach w Wielkiej Brytanii.",
          list: {
            heading:
              "Nagrodę otrzymujemy pod koniec miesiąca, w zależności od miesięcznej kwoty, jaką zapłaciła nam rodzina, lub w następujący sposób:",
            items: {
              p1:
                "W przypadku miesięcznych płatności w wysokości od 50 do 70 funtów - otrzymujesz kartę podarunkową o wartości 5,00 GBP",
              p2:
                "W przypadku płatności miesięcznych o wartości od 70 do 120 funtów - otrzymujesz kartę podarunkową o wartości 10,00 GBP",
              p3:
                "W przypadku miesięcznych płatności dla nas o wartości powyżej 120 £ - otrzymujesz kartę podarunkową na 15,00 £",
            },
            conclusion:
              "Opłata pocztowa, którą nam płacisz, NIE jest obciążana płatnościami za usługi!",
          },
        },
        container_3: {
          heading: "Regulamin",
          p1:
            "Promocja jest ważna tylko dla klientów, którzy płacą nam regularnie.",
          p2:
            "Promocja nie dotyczy tych z Państwa, którzy już z nami nie pracują.",
          p3: "Promocja obowiązuje tylko na jeden kupon rodzinny.",
          p4:
            "Promocja dotyczy tylko Klientów, którzy będą korzystać z usług socjalnych - zasiłków socjalnych, macierzyństwa państwowego, dzieci, usług - zwrotu nadpłaconego podatku i wszystkich innych BEZ rozliczania się osób ubezpieczonych i spółek z ograniczoną odpowiedzialnością.",
          conclusion:
            "Program promocyjny obowiązuje od 01.10.2020 do 31.12.2020 włącznie **!",
        },
        footer:
          "** W przypadku nadużyć zastrzegamy sobie prawo do wycofania promocji w dowolnym momencie bez uprzedzenia!",
      },
    },
    forms: {
      download_file: "Pobierz plik",
      dokument: {
        heading:
          "Formularze i formularze do usług księgowych, które wykonujemy w biurze DoKument",
        p1: "Możesz skorzystać z tego formularza, aby zgłosić mile biznesowe:",
        p2:
          "Aby zgłosić zarobki gotówkowe, możesz skorzystać z tego formularza:",
        p3:
          "Aby wyznaczyć pracownika / dyrektora pracy, skorzystaj z formularza:",
        p4: "Aby zgłosić płatności dla podwykonawców, skorzystaj z formularza:",
        p5:
          "Aby zarejestrować się jako osoba samozatrudniona, wypełnij następujący formularz:",
        p6:
          "Aby zarejestrować spółkę z ograniczoną odpowiedzialnością, wypełnij następujący formularz:",
      },
      biurokrat: {
        heading:
          "Formularze do usług socjalnych, które wykonujemy w biurze Biurokrat",
        p1:
          "Aby ubiegać się o numer ubezpieczenia prosimy skorzystać z poniższego formularza:",
        p2:
          "Aby ubiegać się o Universal Credit, skorzystaj z następującego formularza:",
        p3:
          "Aby ubiegać się o zasiłek dla osób niepełnosprawnych, użyj poniższego formularza:",
        p4:
          "Aby poprosić o numer referencyjny ubezpieczenia emerytalnego, użyj poniższego formularza:",
        p5: "Aby ubiegać się o zasiłek rodzinny, użyj poniższego formularza:",
        p6:
          "Aby uzyskać pomoc w zapisaniu dziecka / dzieci do szkoły, skorzystaj z następującego formularza:",
        p7:
          "Aby ubiegać się o certyfikat - dowód doświadczenia zdobytego w Wielkiej Brytanii i / lub uznanie ubezpieczenia zdrowotnego, skorzystaj z poniższego formularza:",
      },
    },
  },
  monday: "Poniedziałek:",
  tuesday: "Wtorek:",
  wednesday: "Środa:",
  thursday: "Czwartek:",
  friday: "Piątek:",
  saturday: "Sobota:",
};
